import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import "./i18n/index.js";
import "./styles/bootstrap-overrides.scss";
import "./styles/tgwe-theme.scss";

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
